import { Actions } from './dashboard.actions';
import { fromJS } from 'immutable';
import * as dashboardTypes from './dashboard.types';



export const initialState = fromJS(
    {
        propertyGeneral: {
            isLoading: false,
            shouldReload: false,
            data: {},
        },
        businessGeneral: {
            isLoading: false,
            shouldReload: false,
            data: {},
        }
    }
)


export function dashboardReducer(state = initialState, action: Actions) {

    switch (action.type) {

        case dashboardTypes.FETCH_PROPERTY_GENERAL_REQUEST: {
            return state
                .setIn(['propertyGeneral', 'isLoading'], true)
        }

        case dashboardTypes.FETCH_PROPERTY_GENERAL_SUCCESS: {
            return state
                .setIn(['propertyGeneral', 'isLoading'], false)
                .setIn(['propertyGeneral', 'data'], fromJS(action.payload))
        }

        case dashboardTypes.FETCH_PROPERTY_GENERAL_FAILURE: {
            return state
                .setIn(['propertyGeneral', 'isLoading'], false)
        }


        case dashboardTypes.FETCH_BUSINESS_GENERAL_REQUEST: {
            return state
                .setIn(['businessGeneral', 'isLoading'], true)
        }

        case dashboardTypes.FETCH_BUSINESS_GENERAL_SUCCESS: {
            return state
                .setIn(['businessGeneral', 'isLoading'], false)
                .setIn(['businessGeneral', 'data'], fromJS(action.payload))
        }

        case dashboardTypes.FETCH_BUSINESS_GENERAL_FAILURE: {
            return state
                .setIn(['businessGeneral', 'isLoading'], false)
        }

        case dashboardTypes.UPDATE_FIELD:
            let fields = [];

            if (action.path === '') {
                fields = action.field.split('.');
            } else {
                fields = action.path
                    .split('.')
                    .concat(action.field.split('.'));
            }
            const value = action.value;

            if (fields.length === 1) {
                return state.set(fields[0], fromJS(value));
            }
            return state.setIn(fields, fromJS(value));
        case dashboardTypes.SET_DEFAULT_DATA:
            const path = action.path || '';
            return state.setIn(
                path.split('.'),
                initialState.getIn(path.split('.'))
            );

        default: return state;
    }
}